import Vue from 'vue';
import Router from 'vue-router';

Vue.use( Router );

let appRouter = new Router({
    mode: 'history',
    routes: [
        // generated-routes
        {
            path: '/ending',
            name: 'Ending',
            component: () =>
            {
                return import( /* webpackChunkName: "ending" */ '@/app/pages/Ending' );
            }
        },
        {
            path: '/game',
            name: 'GameView',
            component: () =>
            {
                return import( /* webpackChunkName: "game-view" */ '@/app/pages/GameView' );
            }
        },
        {
            path: '/',
            name: 'Landing',
            component: () =>
            {
                return import( /* webpackChunkName: "landing" */ '@/app/pages/Landing' );
            }
        }
    ]
});

appRouter.beforeEach( ( to, from, next ) =>
{
    if( typeof to.beforeEnter === 'function' ) // check if the route has a beforeEnter function
    {
        to.beforeEnter( to, from, next );
        return;
    }

    if( to.name !== 'Landing' && !from.name )
    {
        next( '/' );

        if( window.ga )
        {
            window.ga( 'send', 'pageview', to.path );
        }

        return;
    }

    if( window.ga )
    {
        window.ga( 'send', 'pageview', to.path );
    }

    next();
});

export default appRouter;
